import { Component, h, Prop, Host } from '@stencil/core';

@Component({
  tag: 'pn-proxio-productcard-description',
  styleUrl: 'pn-proxio-productcard-description.scss',
})
export class PnProxioProductcardDescription {
  @Prop() heading: string;
  @Prop() highlight: string;
  @Prop() description: string;
  @Prop({ mutable: true }) list: string[] = [];

  render() {
    return (
      <Host>
        {this.heading ? <h3>{this.heading}</h3> : null}
        {this.highlight ? <h3 class="highlight">{this.highlight}</h3> : null}
        {this.description ? <span>{this.description}</span> : null}
        {this.list ? (
          <ul>
            {this.list.map(text => {
              return <li>{text}</li>;
            })}
          </ul>
        ) : null}
      </Host>
    );
  }
}
